import { ShimmerLines, TableShimmer } from '@/lib/shimmer';

/**
 * A wait in the design system's shimmer (`TShimmerBox`), as the detail pages draw theirs: grey
 * blocks where what is coming will land, so the page fills in rather than jumps. `label` names the
 * wait for a screen reader ("Loading staff").
 *
 * `lines` is a few lines of text, for a section, a dialog or a list in a box; `table` is a list's
 * table — a header and rows. Either fades in after a beat, so a wait that ends quickly shows
 * nothing rather than a flash of grey.
 *
 * Not for a button that is busy, which keeps its own `Spinner`.
 */
export function Loading({
  label,
  shape = 'lines',
}: {
  label: string;
  shape?: 'lines' | 'table';
}) {
  return (
    <div
      role="status"
      aria-label={label}
      className="flex w-full flex-1 flex-col motion-safe:animate-in motion-safe:fade-in motion-safe:fill-mode-both motion-safe:delay-150 motion-safe:duration-300"
    >
      {shape === 'table' ? <TableShimmer /> : <ShimmerLines />}
    </div>
  );
}
